import React from "react";
import { GenreContentListItemTemplate } from "themes/administration/genre/components";

function GenreContentListItem(props) {
    return <GenreContentListItemTemplate {...props} />;
}

export default GenreContentListItem;
